export const contactsData = {
    email: 'mangukiyamanav4245@gmail.com',
    phone: '+91 9558724245',
    address: 'Gujarat, India.',

    sheetAPI: ''
}